<template lang="pug">
div.main-container#app
	md-whiteframe(md-tag="md-toolbar", md-elevation="2")
		router-link.md-icon-button(tag="md-button", to='./')
			md-icon home
		h1.md-title.fullwidth Nicolas Bonnefoy
		md-button.md-icon-button(href="https://www.linkedin.com/in/nbonnefoy/", target="_blank")
			md-icon.fa.fa-linkedin-square.fa-2x
	transition(:name="transitionName")
		router-view(name="page")
	md-menu(md-size="4", md-direction="top left", @close="menuClosed", @open="menuOpened", ref="menu", :md-offset-y="-50", :md-offset-x="-80")
		md-button.md-fab.md-fab-bottom-right(md-menu-trigger)
			md-icon contacts
		md-menu-content
			div.row
				div.col-xs-12.text-center
					h3 Fixons un rendez-vous !
			div.row
				div.col-xs-12.text-center
					transition(name="slide-btn")
						md-button.md-icon-button.md-raised.md-primary.contact-btns(href="https://www.linkedin.com/in/nbonnefoy/", target="_blank", v-show="animMenuShow")
							md-icon.fa.fa-linkedin-square.fa-2x
					transition(name="slide-btn1").d1
						md-button.md-icon-button.md-raised.md-primary.contact-btns(href="tel:+33650624443", v-show="animMenuShow")
							md-icon phone
					transition(name="slide-btn2").d2
						md-button.md-icon-button.md-raised.md-primary.contact-btns(href="mailto:contact@nicolasbonnefoy.com?subject=Prise de contact", v-show="animMenuShow")
							md-icon mail
</template>

<script>
export default {
	methods: {
		menuOpened(){
			this.animMenuShow = true
		},
		menuClosed(){
			this.animMenuShow = false
		}
	},
	data(){ return {
		transitionName: 'slide',
		animMenuShow: false
	}},
	computed: {
	
	},
	created(){
	
	}
}
</script>

<style lang="stylus">
	@import '../styles/variables'
	@import '../styles/helpers'
.bg-img
	background: url(/assets/bg-snow.jpg) no-repeat center center
	background-size: cover
	min-height: 3%
.slogan
	margin-top: 5vh
	color: color-brown
.cta
	margin: 1% 0

.card-container
	margin-top: 10px
.md-title
	&.fullwidth
		flex: 1
.simple-footer
	margin-top: 40px


.fade-enter-active, .fade-leave-active {
	transition: opacity .5s ease;
}
.fade-enter, .fade-leave-active {
	opacity: 0
}

//animation btn icons
.slide-btn2-enter-active
	animation: slide-in .5s cubic-bezier(.57,.1,.22,.94)
.slide-btn2-leave-active
	animation: slide-out .2s cubic-bezier(.11,.6,.22,.94)

.slide-btn1-enter-active
	animation: slide-in .7s cubic-bezier(.57,.1,.22,.94)
.slide-btn1-leave-active
	animation: slide-out .3s cubic-bezier(.11,.6,.22,.94)

.slide-btn-enter-active
	animation: slide-in .8s cubic-bezier(.57,.1,.22,.94)
.slide-btn-leave-active
	animation: slide-out .4s cubic-bezier(.11,.6,.22,.94)
	
@keyframes slide-in
	0%
		opacity: 0
		transform: translateX(180px)
	100%
		opacity: 1
		transform: translateX(0)
@keyframes slide-out
	0%
		opacity: 1
		transform: translateX(0)
	100%
		opacity: 0
		transform: translateX(180px)

//page transition
.slide-enter-active, .slide-leave-active
	transition: all .3s
	overflow-y: auto;
	overflow-x: hidden;
.slide-left-enter, .slide-leave-to
	opacity: 0
	-ms-flex: 0;
	flex: 0;
.slide-enter-to, .slide-leave
	opacity: 1
	-ms-flex: 1;
	flex: 1;
	
</style>

<style lang="stylus" scoped>
.md-button.md-icon-button.contact-btns
	margin-right: 10px
	margin-left: 10px
	margin-bottom: 10px
</style>


// WEBPACK FOOTER //
// src/components/App.vue